var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIconRound = function SvgCloseIconRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#777",
    opacity: 0.498
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "m5.977 6.439 10.07 9.726M15.4 6.439 5.32 16.18"
  }))));
};
export default SvgCloseIconRound;